import { CoreState } from "../state";

import { Jurisdiction } from "./jurisdiction.model";

export namespace JurisdictionSelector {
	export const get = (state: CoreState): Jurisdiction | undefined => state.jurisdiction.jurisdiction;
}
